import { useStore } from "hooks/use-store";
import { useTrackWidget } from "hooks/use-analytics";
import { CombinedGauges } from "./combined-gauges";
import { SafetyGauges } from "./safety-gauges";
import { BasicGauges } from "./basic-gauges";
import { EcoGauges } from "./eco-gauges";

export const Gauges = () => {
  // Speed mode toggles from the toolbar
  const safetySpeedEnabled = useStore((state) => state.safetySpeedEnabled);
  const ecoSpeedEnabled = useStore((state) => state.ecoSpeedEnabled);

  // Determine which mode is active based on the speed toggles
  const isCombinedMode = safetySpeedEnabled && ecoSpeedEnabled;
  const isEcoMode = !safetySpeedEnabled && ecoSpeedEnabled;
  const isSafetyMode = safetySpeedEnabled && !ecoSpeedEnabled;

  useTrackWidget(
    `gauges.${
      isCombinedMode
        ? "combined"
        : isEcoMode
        ? "eco"
        : isSafetyMode
        ? "safety"
        : "basic"
    }`
  );

  // If both speeds are enabled, show combined gauges
  if (isCombinedMode) {
    return <CombinedGauges />;
  }

  // If only eco speed is enabled, show eco gauges
  if (isEcoMode) {
    return <EcoGauges />;
  }

  // If only safety speed is enabled, show safety gauges
  if (isSafetyMode) {
    return <SafetyGauges />;
  }

  // If neither speed is enabled, show basic gauges
  return <BasicGauges />;
};
